import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import { useRegisterPageContainerError } from '../../../components/layout/page-container/page-container-error-handler';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import withRouter from '../../../hoc/with-router';
import { useRestrictions } from '../../../hooks/use-restrictions';
import { useGetProgramItems } from '../../../redux/api/programsAPI';
import { Paths } from '../../../shared/paths';
import ProgramItemsList from '../shared/program-items-list/ProgramItemsList';
import { useStyles } from './ProgramItems.styles';

interface ProgramItemsProps {
  setPlanDialogOpen: (open: boolean) => void;
}

function ProgramItems({ setPlanDialogOpen }: ProgramItemsProps) {
  const { t } = useTranslation();
  const { navigate } = useNavigationStack();
  const {
    data: programItems,
    isLoading,
    isUninitialized,
    error,
    refetch,
  } = useGetProgramItems();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const isDataLoading = isLoading && !isUninitialized;
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading: isDataLoading,
    hasData: Boolean(programItems?.length),
    onRetry: handleRetry,
  });

  const { isShowAddButton, isShowPlanDialogOnClick } = useRestrictions();

  function onAddClick() {
    if (isShowPlanDialogOnClick?.programItem) {
      setPlanDialogOpen(true);
    } else {
      navigate(Paths.programs.toNewItem);
    }
  }

  return (
    <ProgramItemsList
      programItems={programItems ?? null}
      onAddClick={isShowAddButton?.programItem && onAddClick}
      isLoading={isDataLoading}
    />
  );
}

export default withRouter(ProgramItems);
